// extracted by mini-css-extract-plugin
module.exports = {"content":"CaseReassignedAvatars_content__2jsOl","first":"CaseReassignedAvatars_first__28xOv","second":"CaseReassignedAvatars_second__2BuKR"};